// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__Lycx4","input":"styles_input__14EZ7","dataBlock":"styles_dataBlock__usKc1","noOption":"styles_noOption__4qkSF"};